import { useEffect, useState } from "react";

/**
 * @see https://usehooks.com/useDebounce/
 */
export const useDebouncedValue = <T = any>(value: T, delay = 150) => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};
